import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Avatar, RoleBadge } from "@/components/Brand";
import { Search } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

export default function Members() {
  const [data, setData] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/members", { params: { search: search || undefined } }).then(({ data }) => setData(data));
    }, 250);
    return () => clearTimeout(t);
  }, [search]);

  return (
    <div className="fade-in">
      <PageHeader title="Members" subtitle="Browse and search the network." />

      <div className="relative mb-6 max-w-md">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <input
          data-testid="members-search-input"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by name or company…"
          className="h-10 w-full rounded-lg border border-input bg-card pl-9 pr-3 text-sm outline-none focus:ring-2 focus:ring-ring"
        />
      </div>

      {!data ? (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{[0,1,2,3,4,5].map(i => <Skeleton key={i} className="h-36 rounded-xl" />)}</div>
      ) : (
        <>
          <p className="mb-4 text-sm text-muted-foreground"><span className="tnum">{data.total}</span> members</p>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="members-grid">
            {data.members.map((m) => (
              <div key={m.id} className="card-surface p-5" data-testid={`member-${m.id}`}>
                <div className="flex items-center gap-3">
                  <Avatar src={m.photo_url} name={m.name} size={48} />
                  <div className="min-w-0">
                    <div className="truncate font-semibold">{m.name}</div>
                    <div className="truncate text-sm text-muted-foreground">{m.job_title || "Member"}</div>
                  </div>
                </div>
                <div className="mt-3 flex items-center justify-between">
                  <RoleBadge role={m.role} />
                  <span className="tnum text-sm font-semibold text-[#1779AC] dark:text-[#5cc7ef]">{m.points} pts</span>
                </div>
                <div className="mt-3 truncate text-sm text-muted-foreground">{m.company}</div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
